(() => {
  const SECTION = 'section.id_recently_viewed';
  const HIDDEN_KEY = 'rec_stash_hidden_session';
  let pageObserver = null;
  let sectionObserver = null;
  let activeSection = null;

  const sessionHidden = () => {
    try { return sessionStorage.getItem(HIDDEN_KEY) === '1'; }
    catch (_) { return false; }
  };

  const setSessionHidden = () => {
    try { sessionStorage.setItem(HIDDEN_KEY, '1'); }
    catch (_) {}
  };

  const productCount = (section) => {
    const box = section.querySelector('.ftf-products');
    if (!box) return 0;
    return [...box.children].filter((node) => node.nodeType === 1).length;
  };

  const enhance = (section) => {
    if (!section) return false;
    if (sessionHidden()) {
      section.classList.add('rec-stash--session-hidden');
      return true;
    }

    const heading = section.querySelector('.ftf-top-heading');
    const title = heading && heading.querySelector('.ftf-section-title span');
    const products = section.querySelector('.ftf-products');
    if (!heading || !title || !products) return false;

    section.classList.add('rec-stash');
    title.textContent = 'REC STASH';

    let kicker = heading.querySelector('.rec-stash__kicker');
    if (!kicker) {
      kicker = document.createElement('span');
      kicker.className = 'rec-stash__kicker';
      kicker.textContent = 'YOUR REC BROWSING TRAIL';
      heading.insertBefore(kicker, heading.firstChild);
    }

    let subtitle = heading.querySelector('.ftf-section-des');
    if (!subtitle) {
      subtitle = document.createElement('span');
      subtitle.className = 'ftf-section-des ftf-subtitle';
      heading.appendChild(subtitle);
    }
    subtitle.textContent = 'You looked at this shit. We kept it here so you do not have to hunt for it again.';

    let tools = heading.querySelector('.rec-stash__tools');
    if (!tools) {
      tools = document.createElement('div');
      tools.className = 'rec-stash__tools';
      tools.innerHTML = '<span class="rec-stash__count" aria-live="polite"></span><button class="rec-stash__hide" type="button">HIDE FOR NOW</button>';
      heading.appendChild(tools);
      tools.querySelector('.rec-stash__hide')?.addEventListener('click', () => {
        setSessionHidden();
        section.classList.add('rec-stash--session-hidden');
        sectionObserver?.disconnect();
      });
    }

    const count = productCount(section);
    const countNode = tools.querySelector('.rec-stash__count');
    if (countNode) countNode.textContent = count === 1 ? '1 PIECE IN YOUR TRAIL' : `${count} PIECES IN YOUR TRAIL`;
    section.dataset.recStashReady = 'true';
    return count > 0;
  };

  const watchSection = (section) => {
    if (!section) return false;
    if (activeSection === section && sectionObserver) return true;
    pageObserver?.disconnect();
    pageObserver = null;
    sectionObserver?.disconnect();
    activeSection = section;

    if (enhance(section)) return true;

    sectionObserver = new MutationObserver(() => {
      if (enhance(section)) {
        sectionObserver?.disconnect();
        sectionObserver = null;
      }
    });
    sectionObserver.observe(section, { childList: true, subtree: true });
    return true;
  };

  const findSection = () => document.querySelector(SECTION);

  const boot = () => {
    const section = findSection();
    if (section) {
      watchSection(section);
      return;
    }
    if (pageObserver) return;
    pageObserver = new MutationObserver(() => {
      const found = findSection();
      if (found) watchSection(found);
    });
    pageObserver.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();